import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { regionChange } from '../../actions';
import { RegionDropdown as RegionDropdownComponent } from '../../components/RegionDropdown';
import { getFilterLocation, getLocationsForSelect } from '../../selectors';
import { TThunkDispatch } from '../../types/redux/thunk';
import { addQueryParameter } from '../../utils';
import { getLocationsInOrder } from './helpers';

export function RegionDropdown() {
  const dispatch: TThunkDispatch = useDispatch();
  const regions = useSelector(getLocationsForSelect);
  const regionsInOrder = React.useMemo(() => getLocationsInOrder(regions), [regions]);
  const selectedRegion = useSelector(getFilterLocation);

  const handleRegionChange = React.useCallback(
    (regionId: number) => {
      dispatch(regionChange(regionId));
      addQueryParameter('location', String(regionId));
    },
    [dispatch],
  );

  return (
    <RegionDropdownComponent regions={regionsInOrder} selectedRegion={selectedRegion} onChange={handleRegionChange} />
  );
}
